module.exports = __webpack_public_path__ + "static/fonts/PostGrotesk-Book.6f0942a8.woff2";